import { useObserver } from "mobx-react";
import { IoClose } from "react-icons/io5";

export default function MockTestAnalyticsPopup({
  TotalAnswered,
  TotalQuestions,
  Apptitude,
  ApptitudeAnswered,
  Reasoning,
  ReasoningAnswered,
  Verbal,
  VerbalAnswered,
  Tech,
  TechAnswered,
  handleSubmit,
  handleCancel,
}) {
  return useObserver(() => (
    <div className=" absoulte h-screen w-screen overflow-y-auto z-[500] rounded fixed bottom-0 left-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40  shadow-lg gil-reg overflow-x-hidden no-scrollbar">
      {/* absolute w-screen gil-reg h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40  */}
      <div className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-lg overflow-y-hidden items-center md:w-[40%] lg:w-[60%] w-[95%] h-[45%] md:h-[50%] lg:h-[50%] m-auto shadow-lg  no-scrollbar">
        <div className="w-full flex flex-col justify-center gap-8 items-center">
          <h1 className="text-2xl px-4 font-semibold text-primary">
            You have attempted {TotalAnswered ?? 0} questions out of{" "}
            {TotalQuestions ?? 0}
          </h1>
          <ul className="mt-2 lg:mt-0 space-y-3 text-gray-600 text-xl w-full grid grid-cols-2 gap-4 px-[10%]">
            <li className="flex flex-row items-center sm:border-l-2 md:border-l-2 border-l-2 border-primary pl-[1%]  mt-3">
              Apptitude: {ApptitudeAnswered ?? 0}/{Apptitude ?? 0}
            </li>
            <li className="flex flex-row items-center sm:border-l-2 md:border-l-2 border-l-2 border-primary pl-[1%]">
              Reasoning: {ReasoningAnswered ?? 0}/{Reasoning ?? 0}
            </li>
            <li className="flex flex-row items-center sm:border-l-2 md:border-l-2 border-l-2 border-primary pl-[1%]">
              Verbal: {VerbalAnswered ?? 0}/{Verbal ?? 0}
            </li>

            <li className="flex flex-row items-center sm:border-l-2 md:border-l-2 border-l-2 border-primary pl-[1%]">
              Technical: {TechAnswered ?? 0}/{Tech ?? 0}
            </li>
          </ul>
          <div className="px-[10%] w-full flex justify-between items-center">
            <button
              className="bg-primary text-white px-4 h-10 rounded-lg"
              onClick={() => {
                // if the total answered questions is less than 10% of the  total questions then alert
                if (TotalAnswered < TotalQuestions * 0.1) {
                  alert("You must attempt atleast 10% of the questions");
                  return;
                }
                handleSubmit();
              }}
            >
              Submit All Questions
            </button>
            <button
              className="border border-primary px-4 h-10 rounded-lg"
              onClick={handleCancel}
            >
              Review
            </button>
          </div>
        </div>
      </div>
    </div>
  ));
}
